// extracted by mini-css-extract-plugin
export default {"container":"style_container__SO15j","textH3":"style_textH3__girEc","contentNotSelf":"style_contentNotSelf__H1d8v","top":"style_top__QwNth","input":"style_input__p8eEf"};